/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ATLunchBenefitOptionsDTO } from './atlunch-benefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { ATMobilityBenefitOptionsDTO } from './atmobility-benefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { BAVBenefitOptionsDTO } from './bavbenefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { BikeBenefitOptionsDTO } from './bike-benefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { CouponsBenefitOptionsDTO } from './coupons-benefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { CouponsV2BenefitOptionsDTO } from './coupons-v2-benefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { CustomBenefitOptionsDTO } from './custom-benefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { FlexBenefitOptionsDTO } from './flex-benefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { InternetBenefitOptionsDTO } from './internet-benefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { KitaBenefitOptionsDTO } from './kita-benefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { LunchBenefitOptionsDTO } from './lunch-benefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { MobilityBenefitOptionsDTO } from './mobility-benefit-options-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { RecreationBenefitOptionsDTO } from './recreation-benefit-options-dto';

/**
 * 
 * @export
 * @interface BenefitActivationDTO
 */
export interface BenefitActivationDTO {
    /**
     * 
     * @type {string}
     * @memberof BenefitActivationDTO
     */
    'benefit': BenefitActivationDTOBenefitEnum;
    /**
     * 
     * @type {string}
     * @memberof BenefitActivationDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BenefitActivationDTO
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof BenefitActivationDTO
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BenefitActivationDTO
     */
    'benefitTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BenefitActivationDTO
     */
    'benefitTemplateName'?: string;
    /**
     * 
     * @type {LunchBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'lunchOptions'?: LunchBenefitOptionsDTO;
    /**
     * 
     * @type {MobilityBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'mobilityOptions'?: MobilityBenefitOptionsDTO;
    /**
     * 
     * @type {CouponsBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'couponsOptions'?: CouponsBenefitOptionsDTO;
    /**
     * 
     * @type {CouponsV2BenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'couponsV2Options'?: CouponsV2BenefitOptionsDTO;
    /**
     * 
     * @type {InternetBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'internetOptions'?: InternetBenefitOptionsDTO;
    /**
     * 
     * @type {KitaBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'kitaOptions'?: KitaBenefitOptionsDTO;
    /**
     * 
     * @type {BAVBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'bavOptions'?: BAVBenefitOptionsDTO;
    /**
     * 
     * @type {BikeBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'bikeOptions'?: BikeBenefitOptionsDTO;
    /**
     * 
     * @type {FlexBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'flexOptions'?: FlexBenefitOptionsDTO;
    /**
     * 
     * @type {RecreationBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'recreationOptions'?: RecreationBenefitOptionsDTO;
    /**
     * 
     * @type {CustomBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'customBenefitOptions'?: CustomBenefitOptionsDTO;
    /**
     * 
     * @type {ATLunchBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'atLunchOptions'?: ATLunchBenefitOptionsDTO;
    /**
     * 
     * @type {ATMobilityBenefitOptionsDTO}
     * @memberof BenefitActivationDTO
     */
    'atMobilityOptions'?: ATMobilityBenefitOptionsDTO;
}

export const BenefitActivationDTOBenefitEnum = {
    Bav: 'BAV',
    Lunch: 'LUNCH',
    Coupons: 'COUPONS',
    CouponsV2: 'COUPONS_V2',
    Mobility: 'MOBILITY',
    Gifts: 'GIFTS',
    Internet: 'INTERNET',
    Bike: 'BIKE',
    News: 'NEWS',
    Flex: 'FLEX',
    Recreation: 'RECREATION',
    Bikeleasing: 'BIKELEASING',
    BikeleasingV2: 'BIKELEASING_V2',
    Fitness: 'FITNESS',
    Kita: 'KITA',
    CreditCard: 'CREDIT_CARD',
    DiscountCode: 'DISCOUNT_CODE',
    Custom: 'CUSTOM',
    AtLunch: 'AT_LUNCH',
    AtMobility: 'AT_MOBILITY',
    Car: 'CAR',
    ItLeasing: 'IT_LEASING',
    Wellpass: 'WELLPASS'
} as const;

export type BenefitActivationDTOBenefitEnum = typeof BenefitActivationDTOBenefitEnum[keyof typeof BenefitActivationDTOBenefitEnum];


